import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface UserInfo {
  id: string
  username: string
}

export const useUserStore = defineStore('user', () => {
  const token = ref<string | null>(localStorage.getItem('ra_token'))
  const user = ref<UserInfo | null>(null)

  function setSession(tokenValue: string, userInfo: UserInfo) {
    token.value = tokenValue
    user.value = userInfo
    localStorage.setItem('ra_token', tokenValue)
  }

  function clearSession() {
    token.value = null
    user.value = null
    localStorage.removeItem('ra_token')
  }

  return { token, user, setSession, clearSession }
})
